import i18n from '@/locales';
import { createApp } from 'vue';
import ProjectsByRegionPurchaseBrowsing from '@/components/purchase/ProjectsByRegionPurchaseBrowsing.vue';

const app = createApp({});
app.use(i18n);
app.component('ProjectsByRegionPurchaseBrowsing', ProjectsByRegionPurchaseBrowsing);
app.mount('#projectsByRegionPurchaseBrowsingApp');
